/** Kort relativ tid på norsk: "5 min siden", "3 t siden", "2 d siden". */
export function relTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const s = Math.round(diff / 1000);
  if (s < 60) return "nå nettopp";
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min siden`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} t siden`;
  const d = Math.round(h / 24);
  if (d < 30) return `${d} d siden`;
  return new Date(iso).toLocaleDateString("nb-NO");
}

export function absTime(iso: string): string {
  return new Date(iso).toLocaleString("nb-NO");
}
